import type { ISubscribedPlan } from '@src/quince-site-common/src/domains/Subscription'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductSubscriptionDeliveryMessageDS } from './product-subscription-delivery-message-ds'
import { ProductSubscriptionDeliveryMessageLegacy } from './product-subscription-delivery-message-legacy'

const ProductSubscriptionDeliveryMessage = (props: { subscribedPlan: ISubscribedPlan; isInStock?: boolean }) => {
  if (shouldUseDesignSystem()) {
    return <ProductSubscriptionDeliveryMessageDS {...props} />
  }
  return <ProductSubscriptionDeliveryMessageLegacy {...props} />
}

export default ProductSubscriptionDeliveryMessage
